import React from 'react';
import { Group, Circle } from 'react-konva';
import getLocaleColour from './MapColouring'

const spacing = 50;
const roomsize = 12;

function SimpleRoom(props) {

    let room = props.room;
    let piX = room.x;
    let piY = room.y;
    let roomid = room.roomid;
    let locale = room.locale;
    let mobcount = room.mobcount;
    let activeroom = props.activeroom;
    let clickHandler = props.clickHandler;

    piY = piY * -1;

    let roomColor = getLocaleColour(locale);
    let borderColour = 'grey';
    let textColour = 'red'
    let borderWidth = 1;

    let displayACtiveMarker = false;

    if (activeroom != undefined) {

        if (activeroom.id === roomid) {
            displayACtiveMarker = true;
            borderColour = 'gold';
        }
    }

    const x = piX * spacing;
    const y = piY * spacing;
    let colorStops = [0, roomColor, 0.7, 'pink', 1, 'red'];
    let colorStops2 = [0, 'white', 0.6, roomColor];   
    return (

        <Group key={roomid}>
            {displayACtiveMarker ?
                <>
                    <Circle id={roomid} x={x} y={y} radius={roomsize + 12} stroke={"pink"} strokeWidth={1} />
                    <Circle id={roomid} x={x} y={y} radius={roomsize + 4}
                        fillRadialGradientStartPoint={{ x: 0, y: 0 }}
                        fillRadialGradientStartRadius={0}
                        fillRadialGradientEndPoint={{ x: 0, y: 0 }}
                        fillRadialGradientEndRadius={roomsize + 4}
                        fillRadialGradientColorStops={colorStops} />
                    <Circle id={roomid} x={x} y={y} radius={roomsize - 2} 
            
                        fillRadialGradientStartPoint={{ x: 0, y: 0 }}
                        fillRadialGradientStartRadius={0}
                        fillRadialGradientEndPoint={{ x: 0, y: 0 }}
                        fillRadialGradientEndRadius={roomsize}
                        fillRadialGradientColorStops={colorStops2}
                        onClick={() => clickHandler(roomid)} />

                </>

                : <Circle id={roomid} x={x} y={y} radius={roomsize} fill={roomColor} stroke={borderColour} strokeWidth={borderWidth} onClick={() => clickHandler(roomid)} />
            }
        </Group>

    )
}

export default SimpleRoom;